//replace SEO internal product link to collection link  
document.querySelectorAll('.product-card a[data-target]').forEach(it => it.addEventListener('click', evt=>{
  evt.preventDefault();
  window.location.href = it.dataset.target;
}));